import React from 'react'
import { Outlet } from 'react-router-dom'

const MainLayout = () => {  
  return (
    <div className="min-h-full min-w-full">
      <Outlet />
    </div>
  )
}

export default MainLayout
